import { DefaultObject, SimpleInput } from "@gsd/backoffice-ui";
import { Field, Form, Formik } from "formik";
import { Component } from "react";
import { Button, FormGroup, Label } from "reactstrap";

import * as Yup from "yup";

const ValidateSchema = Yup.object().shape({
  email: Yup.string().required("Campo obbligatorio"),
  name: Yup.string().required("Campo obbligatorio"),
  lastname: Yup.string().required("Campo obbligatorio"),
});

interface FormModel {
  //uid: number,
  email: string;
  name: string;
  lastname: string;
}

type FormProps = {
  onSubmit: (values: FormModel) => void | Promise<any>;
  initialValues: FormModel;
};

export default class FormUser extends Component<FormProps> {
  render() {
    const defaultValues = {
      email: "",
      name: "",
      lastname: "",
    };
    const { initialValues } = this.props;
    const formValues = DefaultObject(initialValues, defaultValues);

    return (
      <Formik
        initialValues={formValues}
        validationSchema={ValidateSchema}
        validateOnBlur
        isInitialValid={true}
        onSubmit={this.props.onSubmit}
      >
        {(formmikProps) => {
          return (
            <Form>
              <FormGroup>
                <Label for="email">Email o username *</Label>
                <Field name="email" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="name">Nome *</Label>
                <Field name="name" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="lastname">Cognome *</Label>
                <Field name="lastname" type={"text"} component={SimpleInput} />
              </FormGroup>
              <div className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  className="px-5"
                  type="submit"
                  disabled={!formmikProps.isValid || formmikProps.isSubmitting}
                >
                  Salva
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
